import { render } from "./RichTextMenu.vue?vue&type=template&id=6e96f13a&scoped=true"
import script from "./RichTextMenu.vue?vue&type=script&lang=js"
export * from "./RichTextMenu.vue?vue&type=script&lang=js"

import "./RichTextMenu.vue?vue&type=style&index=0&id=6e96f13a&lang=scss&scoped=true"
import "./RichTextMenu.vue?vue&type=style&index=1&id=6e96f13a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e96f13a"]])

export default __exports__